import { Link } from 'react-router-dom';
import ArrowIcon from '../../../../ArrowIcon/ArrowIcon';
import useRoutes from '../../../../../hooks/useRoutes';

interface PeersetButtonProps {
  peerset: any;
  popoverTarget: string;
  triggerId: string;
}

const PeersetButton = ({
  peerset,
  popoverTarget,
  triggerId,
}: PeersetButtonProps) => {
  const routes = useRoutes();

  if (peerset.peersets) {
    return (
      <button
        className={popoverTarget}
        id={triggerId}
        {...(peerset.hint && {
          'data-pr-tooltip': peerset.hint,
          'data-pr-position': 'bottom',
          'data-pr-mouseTrack': true,
        })}
      >
        <span>{peerset.label}</span>
        <ArrowIcon direction="down" color="dark" />
      </button>
    );
  }

  return (
    <Link
      className="peerset-label"
      to={routes.datasetList(peerset.datasetId)}
      {...(peerset.hint && {
        'data-pr-tooltip': peerset.hint,
        'data-pr-position': 'bottom',
        'data-pr-mouseTrack': true,
      })}
    >
      <span>{peerset.label}</span>
    </Link>
  );
};

export default PeersetButton;
